<template>
  <el-row>
    <el-col :span="24">
      <el-table :data="data" style="width: 100%">
        <el-table-column
          type="index"
          :label="$t('lang.external.personal.content.two.序号')"
          align="center"
          width="100"
        />
        <el-table-column
          prop="courseName"
          :label="$t('lang.external.personal.content.two.实验名称')"
          align="center"
          min-width="40%"
        />
        <el-table-column
          prop="score"
          :label="$t('lang.external.personal.content.two.分数')"
          align="center"
          min-width="20%"
        />
        <el-table-column
          :label="$t('lang.external.personal.content.two.批改')"
          align="center"
          min-width="20%"
        >
          <template slot-scope="scope">
            <el-button type="text">
              <span :class="scope.row.status ? 'cl-666' : 'color-b'">
                {{
                  scope.row.status
                    ? $t('lang.external.personal.content.two.已批改')
                    : $t('lang.external.personal.content.two.未批改')
                }}
              </span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('lang.external.personal.content.two.操作')"
          align="center"
          min-width="20%"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleChange(scope.row)">
              <span class="color-o">{{
                $t('lang.external.personal.content.two.查看报告')
              }}</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'report',
  components: {},
  props: ['data'],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleChange(val) {
      this.$emit('change', false, val)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>